import { styled } from 'styled-components'
import TouLogo from '../asset/TOULogo'
import TOULogoTitle from '../asset/TOULogoTitle'
import { LoginIllust } from '../asset/LoginIllust'
import { useState, useEffect } from 'react'
import axios, { AxiosError } from 'axios'
import { useNavigate } from 'react-router-dom'

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
`

const Left = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const LoginForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 266px;
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  svg:first-child {
    width: 44px;
    height: 50px;
  }

  svg:last-child {
    width: 86px;
    height: 26px;
  }
`

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

const InputContainer = styled.div`
  display: flex;
  gap: 16px;
`

const SvgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-size: 12px;
    color: #808080;
  }
  input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #b3b3b3;
    padding: 4px 0;

    outline: none;
  }

  input::placeholder {
    color: #b3b3b3; /* 플레이스홀더 텍스트의 색상을 빨간색으로 설정 */
  }
`

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  padding: 10px 0;
  color: #fff;
  background: #57c9a7;
  cursor: pointer;
`

const Right = styled.div`
  width: 50%;
  background: linear-gradient(
    270deg,
    rgba(87, 201, 167, 1) 0%,
    rgba(87, 201, 167, 1) 96%,
    rgba(194, 236, 223, 1) 96%,
    rgba(194, 236, 223, 1) 100%
  );
  position: relative;
`

const SvgIllust = styled.div`
  position: absolute;

  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);

  svg {
    width: 869.223px;
    height: 501.919px;
  }
`

const ChangePassword = styled.a`
  display: flex;
  justify-content: center;
  text-decoration: underline;
  color: #666;
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #f36464;
  background-color: #ffeded;
  width: 100%;
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  text-align: center;
`

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [status, setStatus] = useState(false)
  const navigate = useNavigate()

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        {
          email,
          password,
        }
      )
      if (response.status === 201) {
        localStorage.setItem('tou-token', response.data?.jwt)

        return navigate('/home/economic-ess', { replace: true })
      }
    } catch (error) {
      const axiosError = error as AxiosError
      console.log('로그인 실패: ', error)
      axiosError && axiosError?.response?.status === 401 && setStatus(true)
    }
  }

  useEffect(() => {
    let timer: NodeJS.Timeout
    if (status) {
      timer = setTimeout(() => {
        setStatus(false)
      }, 3000)
    }
    return () => clearTimeout(timer) // 컴포넌트 언마운트 시 타이머 정리
  }, [status])
  return (
    <Wrapper>
      <Left>
        <LoginForm>
          <Logo>
            <TouLogo />
            <TOULogoTitle />
          </Logo>
          <Form>
            <InputContainer>
              <SvgWrapper>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                >
                  <path
                    d="M21 16.5C22.6569 16.5 24 17.8431 24 19.5V20.2146C24 23.7924 19.7895 26.5 14 26.5C8.21053 26.5 4 23.9333 4 20.2146V19.5C4 17.8431 5.34315 16.5 7 16.5H21ZM14 2.5C17.3137 2.5 20 5.18629 20 8.5C20 11.8137 17.3137 14.5 14 14.5C10.6863 14.5 8 11.8137 8 8.5C8 5.18629 10.6863 2.5 14 2.5Z"
                    fill="#57C9A7"
                  />
                </svg>
              </SvgWrapper>
              <InputWrapper>
                <label htmlFor="id">아이디</label>
                <input
                  type="text"
                  id="id"
                  placeholder="아이디를 입력하세요."
                  onChange={(e) => setEmail(e.target.value)}
                />
              </InputWrapper>
            </InputContainer>

            <InputContainer>
              <SvgWrapper>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="29"
                  viewBox="0 0 28 29"
                  fill="none"
                >
                  <path
                    d="M9 7C9 4.51472 11.0147 2.5 13.5 2.5C15.9853 2.5 18 4.51472 18 7V8.5H19.25C21.3211 8.5 23 10.1789 23 12.25V21.75C23 23.8211 21.3211 25.5 19.25 25.5H7.75C5.67893 25.5 4 23.8211 4 21.75V12.25C4 10.1789 5.67893 8.5 7.75 8.5H9V7ZM13.5 4C11.8431 4 10.5 5.34315 10.5 7V8.5H16.5V7C16.5 5.34315 15.1569 4 13.5 4ZM13.5 18.5C14.3284 18.5 15 17.8284 15 17C15 16.1716 14.3284 15.5 13.5 15.5C12.6716 15.5 12 16.1716 12 17C12 17.8284 12.6716 18.5 13.5 18.5Z"
                    fill="#57C9A7"
                  />
                </svg>
              </SvgWrapper>
              <InputWrapper>
                <label htmlFor="ps">비밀번호</label>
                <input
                  type="password"
                  id="ps"
                  placeholder="비밀번호를 입력하세요."
                  onChange={(e) => setPassword(e.target.value)}
                />
              </InputWrapper>
            </InputContainer>
            {status && (
              <ErrorMessage>
                아이디 또는 비밀번호를 잘못 입력했습니다.
                <br />
                입력하신 내용을 다시 확인해주세요.
              </ErrorMessage>
            )}

            <Button onClick={handleLogin}>로그인</Button>
          </Form>
          <ChangePassword href="/findpassword">
            비밀번호 변경하기
          </ChangePassword>
        </LoginForm>
      </Left>
      <Right>
        <SvgIllust>
          <LoginIllust />
        </SvgIllust>
      </Right>
    </Wrapper>
  )
}
